'use strict'
var twentyninetimes = twentyninetimes || {}

const svgBlue =
  '<div class="animate-circle-word"><svg viewBox="0 0 200 80" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="marking line" d="M118.206 10.2799C83.9601 4.42307 -1.37912 -4.57963 2.10349 32.3683C5.5861 69.3163 69.1437 77.2145 100.487 76.5452C132.991 78.8879 198 73.3323 198 32.3683C198 -8.59572 121.673 0.574324 83.5092 10.2799" stroke="var(--wp--preset--color--brand-blue, #0084c7)" stroke-width="4" stroke-linecap="round"/></svg></div>'
const svgLime =
  '<div class="animate-circle-word"><svg viewBox="0 0 200 80" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="marking line" d="M118.206 10.2799C83.9601 4.42307 -1.37912 -4.57963 2.10349 32.3683C5.5861 69.3163 69.1437 77.2145 100.487 76.5452C132.991 78.8879 198 73.3323 198 32.3683C198 -8.59572 121.673 0.574324 83.5092 10.2799" stroke="var(--wp--preset--color--lime, #D9F642)" stroke-width="4" stroke-linecap="round"/></svg></div>'
const svgOlive =
  '<div class="animate-circle-word"><svg viewBox="0 0 200 80" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="marking line" d="M118.206 10.2799C83.9601 4.42307 -1.37912 -4.57963 2.10349 32.3683C5.5861 69.3163 69.1437 77.2145 100.487 76.5452C132.991 78.8879 198 73.3323 198 32.3683C198 -8.59572 121.673 0.574324 83.5092 10.2799" stroke="var(--wp--preset--color--olive, #A29B30)" stroke-width="4" stroke-linecap="round"/></svg></div>'

twentyninetimes.circlWord =
  twentyninetimes.circlWord ||
  (function () {
    function init() {
      var blueCircles = document.querySelectorAll('.circle-word-blue')
      blueCircles.forEach(function (blueCircle) {
        blueCircle.insertAdjacentHTML('beforeend', svgBlue)
      })

      var limeCircles = document.querySelectorAll('.circle-word-lime')
      limeCircles.forEach(function (limeCircle) {
        limeCircle.insertAdjacentHTML('beforeend', svgLime)
      })

      var oliveCircles = document.querySelectorAll('.circle-word-olive')
      oliveCircles.forEach(function (oliveCircle) {
        oliveCircle.insertAdjacentHTML('beforeend', svgOlive)
      })
    }

    return {
      init: init,
    }
  })()
